import React, {useMemo} from 'react';

import ComputerCharacterImg from "../../assets/ComputerCharacter.png"
import CustomButton from '../../components/common/CustomButton/CustomButton';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function AdvisorConditionsPage({type="Skip/NotLogin"}) {
    const loggedInUser = useSelector((state) => state.auth);
    const navigate = useNavigate();
    console.log("loggedInUser", loggedInUser);
    
    const getRejectedRemark = useMemo(() => {
      if(loggedInUser?.user?.rejection_remark?.length) {
        return loggedInUser?.user?.rejection_remark[loggedInUser?.user?.rejection_remark?.length - 1];
      } else {
        return null;
      }
    }, [loggedInUser])

    if (type==="Status" || type==="RejectionForm") {
      return (
        <>
          {loggedInUser?.user?.advisor_onboarding_status_id?.title === "Rejected" &&
            <div
              className='flex items-center gap-6 p-4 rounded-lg border border-[#D70404] w-full'
              style={{boxShadow: "4px 4px 4px 0px rgba(0, 0, 0, 0.25)"}}
            >
              <AlertIcon color={'#D70404'} />

              <div className='flex flex-col flex-1'>
                <p className='text-[1.25rem] font-[600] text-[#D70404]'>Submission Rejected!</p>
                <p className='text-[0.75rem] font-[500] text-[#D70404]'>Remark: {getRejectedRemark?.reason}</p>
              </div>

              <div>
                {type !== "RejectionForm" &&
                  <CustomButton
                    label='Re-Submit'
                    onClick={() => {navigate('/advisor-onboarding')}}
                  />
                }
              </div>
            </div>
          }
          {(loggedInUser?.user?.advisor_onboarding_status_id?.title === "Pending" || loggedInUser?.user?.advisor_onboarding_status_id?.title === "Re-Submitted") &&
            <div
              className='flex items-center gap-6 p-4 rounded-lg border border-[#FDC83D] w-full'
              style={{boxShadow: "4px 4px 4px 0px rgba(0, 0, 0, 0.25)"}}
            >
              <AlertIcon color={'#FDC83D'} />

              <div className='flex flex-col flex-1'>
                <p className='text-[1.25rem] font-[600] text-[#FDC83D]'>Verification Pending!</p>
                <p className='text-[0.75rem] font-[500] text-[#FDC83D]'>We need to verify your details before granting access.</p>
              </div>

              {/* <div>
                <CustomButton
                  label='Re-Submit'
                  onClick={() => {navigate('/advisor-onboarding')}}
                />
              </div> */}
            </div>
          }
        </>
      )
    }

    if (type==="Skip/NotLogin") {
      return (
        <div className='flex flex-col flex-1'>
            <div className='flex flex-col items-center justify-center flex-1 gap-4'>
                <img className='max-h-60' src={ComputerCharacterImg} alt="ComputerCharacterImg" />
                <p className='text-[2rem] font-[600] text-[#F44336] leading-[1.75rem]'>Onboarding Incomplete</p>
                <p className='text-[1.5rem] font-[600] text-[#213650] leading-[1.75rem]'>Please complete your profile to access all features.</p>
                <div className='mt-8'>
                    <CustomButton label="Complete Profile" onClick={() => {navigate('/advisor-onboarding')}}/>
                </div>
            </div>
        </div>
      )
    }

}

export default AdvisorConditionsPage;

function AlertIcon({color}) {
  return (
    <svg width="52" height="46" viewBox="0 0 52 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.4563 18.3915L23.0511 28.454C23.0848 29.0238 23.559 29.4688 24.1325 29.4688H27.8673C28.1436 29.4687 28.4095 29.3637 28.6105 29.175C28.8115 28.9864 28.9325 28.7285 28.9488 28.454L29.5435 18.3915C29.5801 17.7722 29.0854 17.25 28.4621 17.25H23.5377C22.9145 17.25 22.4198 17.7722 22.4563 18.3915ZM29.7917 34.5C29.7917 36.584 28.0941 38.2734 26 38.2734C23.9059 38.2734 22.2084 36.584 22.2084 34.5C22.2084 32.416 23.9059 30.7266 26 30.7266C28.0941 30.7266 29.7917 32.416 29.7917 34.5ZM29.7535 2.1549C28.0894 -0.715695 23.9137 -0.720906 22.2465 2.1549L0.584743 39.5324C-1.07835 42.4014 1.00372 46 4.33822 46H47.6613C50.9894 46 53.0811 42.4069 51.4148 39.5324L29.7535 2.1549ZM4.80198 40.8791L25.5308 5.12181C25.7393 4.76226 26.2607 4.76226 26.4692 5.12181L47.1981 40.879C47.4064 41.2384 47.1458 41.6874 46.7289 41.6874H5.27115C4.85434 41.6875 4.59371 41.2385 4.80198 40.8791Z" fill={color}/>
    </svg>
  )
}